import React, { Component } from "react";
import AUX from "../../../hoc/Aux_";
import { Link } from "react-router-dom";
import axios from "../../Shared/auth-header";
import $ from "jquery";
import { toast } from "react-toastify";
// import AdvanceFilterModal from "../../Shared/AdvanceFilterModal";
// import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import "react-datepicker/dist/react-datepicker.css";
import Filter from "./Filters";

class AdvanceSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      perms: this.props.perms,
      isLookup: this.props.isLookup,
      page: this.props.args.page,
      filters: [],
      sizePerPage: this.props.args.sizePerPage,
      totalCount: this.props.args.totalCount,
      keyword: "",
      selectedOption: null,
      advSearch: this.props.args.advSearch,
      showActive: this.props.args.showActive,
      pageTitle: this.props.pageTitle || "",
      searchText: "",
      searchText_err: "",
      valid: false,
    };
    this.handleFormSearch = this.handleFormSearch.bind(this);
    this.handleAdvSubmit = this.handleAdvSubmit.bind(this);
    this.propMethods = this.props.propMethods();
    this.addFilter = this.addFilter.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSearchTextChange = this.searchTextChangeHandler.bind(this);

    this.filterHandlers = () => {
      this.changeText = (idx, e) => {
        this.state.filters[idx][e.target.name] = e.target.value;
        this.setState({ filters: this.state.filters });
        this.props.propMethods().updateFilters(this.state.filters);
      };
      this.changeActive = (idx, e) => {
        this.state.filters[idx].isActive = "";
        this.state.filters[idx].isinactive = "";
        this.state.filters[idx][e.target.value] = "true";
        this.setState({ filters: this.state.filters });
        this.props.propMethods().updateFilters(this.state.filters);
      };
      this.changeSelect = (idx, e) => {
        this.state.filters[idx][e.target.name] = e.target.value;
        this.setState({ filters: this.state.filters });
        this.props.propMethods().updateFilters(this.state.filters);
      };
      this.changeTypes = (idx, e) => {
        const add = e.target.checked;
        if (this.state.filters[idx][e.target.name]) {
          if (add) {
            this.state.filters[idx][e.target.name].push(e.target.value);
          } else {
            const index = this.state.filters[idx][e.target.name].indexOf(
              e.target.value
            );
            this.state.filters[idx][e.target.name].splice(index, 1);
          }
        } else {
          this.state.filters[idx][e.target.name] = [];
          this.state.filters[idx][e.target.name].push(e.target.value);
        }

        this.setState({ filters: this.state.filters });
        this.props.propMethods().updateFilters(this.state.filters);
      };
      this.changeComm = (idx, e) => {
        const val = e.target.checked;
        if (val) {
          this.state.filters[idx][e.target.name] = "true";
        } else {
          this.state.filters[idx][e.target.name] = "";
        }

        this.setState({ filters: this.state.filters });
        this.props.propMethods().updateFilters(this.state.filters);
      };
      this.facilityMethods = () => {
        this.updateFacilityId = (args, idx) => {
          this.state.filters[idx]["Facility"] = args.code;
          this.setState({ filters: this.state.filters });
          this.props.propMethods().updateFilters(this.state.filters);
          $(".cancelModal").trigger("click");
        };
        return this;
      };
      return this;
    };
  }
  handleShowActive = (e) => {
    this.setState({ showActive: e.target.checked });
    this.props.propMethods().handleShowActive(e, $("#keyword").val());
  };
  addFilter() {
    const select = document.getElementById("filterType");
    const filterType = select.value;
    const filterLabel = select.options[select.selectedIndex].label;
    const filter = {
      type: {
        label: filterLabel,
        name: filterType,
      },
    };

    this.state.filters.push(filter);
    this.setState({ filters: this.state.filters });
    this.props.propMethods().updateFilters(this.state.filters);
  }
  handleRemove = (e) => {
    const idx = parseInt(e.target.dataset.id);
    this.state.filters.splice(idx, 1);
    this.setState({
      filters: this.state.filters,
    });
    this.props.propMethods().updateFilters(this.state.filters);
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  searchTextChangeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });

    var inputValue = event.target.value.trim();
    if (inputValue !== "") {
      if (
        inputValue.indexOf(" ") > 0 &&
        !(
          /^[a-zA-Z]*$/.test(inputValue.split(" ")[0]) &&
          /^[a-zA-Z]*$/.test(inputValue.split(" ")[1])
        )
      ) {
        /// Contains 2 words &  One of them contains character other than alphabets -- Invalid
        $("#" + event.target.id).addClass("inputBorderRed");
        this.setState({
          [event.target.name + "_err"]: "Name should contain alphabets only.",
        });
        this.setState({ valid: false });
      } else if (
        !(/^[a-zA-Z ]*$/.test(inputValue) || /^[0-9]*$/.test(inputValue))
      ) {
        /// alphanumeric or special characers with one word
        $("#" + event.target.id).addClass("inputBorderRed");
        this.setState({
          [event.target.name + "_err"]: "Alphanumeric is not allowed.",
        });
        this.setState({ valid: false });
      } else {
        $("#" + event.target.id).removeClass("inputBorderRed");
        this.setState({ [event.target.name + "_err"]: "" });
        this.setState({ valid: true });
      }
    } else {
      /// searching with empty field
      this.setState({
        [event.target.name + "_err"]: "No search criteria entered.",
      });
      this.setState({ valid: false });
      $("#" + event.target.id).addClass("inputBorderRed");
    }
  };

  handleAdvSubmit(e) {
    e.preventDefault();
    $(".loading").show();
    const url = `/api/member/AdvanceSearch`;
    const formData = {
      Keyword: $("#keyword").val(),
      PageNo: 1,
      PageSize: this.state.sizePerPage,
      OperatorType: $("#operator").val(),
      SortOrder: this.props.sortOrder,
      Status: this.props.args.showActive ? "Active" : "   ",
    };
    let adSearch = Object.assign(
      {},
      ...this.state.filters.map((el) => {
        let obj = {};
        for (let key in el) {
          if (key != "type") {
            obj[key] = el[key];
          }
          if (key == "MemberType" || key == "careerLevel") {
            obj[key] = el[key].join(",");
          }
        }

        return obj;
      })
    );
    this.props.propMethods().updateColumns(this.state.filters);
    Object.assign(formData, adSearch);
    axios.post(url, formData).then(({ data }) => {
      if (data.status && data.status.toLowerCase() == "success") {
        this.setState({
          data: data.data,
          totalCount: data.totalCount,
          page: 1,
        });
        this.props.updateTable({
          page: 1,
          data: data.data,
          totalCount: data.totalCount,
          keyword: $("#keyword").val(),
        });
        $(".loading").hide();
        $(".advance-search").toggleClass("d-none");
      } else {
        $(".loading").hide();
        toast.error(data.message);
      }
    });
  }
  handleFormSearch(e) {
    this.props.setAdvancedSearch(false);
    e.preventDefault();
    if (this.state.valid) {
      $(".loading").show();
      const url = `/api/member/SearchMembers`;
      const formData = {
        Keyword: $("#keyword")
          .val()
          .trim(),
        Facility: this.props.facility,
        PageNo: 1,
        PageSize: this.state.sizePerPage,
        ShowOnlyActive: this.props.args.showActive,
      };
      axios.post(url, formData).then(({ data }) => {
        if (data.status && data.status.toLowerCase() == "success") {
          this.setState({
            data: data.data,
            totalCount: data.totalCount,
            page: 1,
          });

          this.props.propMethods().updateTable({
            page: 1,
            data: data.data,
            totalCount: data.totalCount,
            keyword: $("#keyword").val(),
          });

          $(".loading").hide();
        } else {
          $(".loading").hide();
          toast.error(data.message);
        }
      });
    } else {
      if (
        $("#keyword")
          .val()
          .trim() === ""
      ) {
        this.setState({ ["searchText_err"]: "No search criteria entered." });
        this.setState({ valid: false });
        $("#keyword").addClass("inputBorderRed");
      }
      return false;
    }
  }
  onAdvancedFilterModal() {
    $(".AdvanceFilterModal").modal();
  }
  componentWillMount() {
    if (this.props.keyword) {
      $("#keyword").val(this.props.keyword);
    }
  }
  render() {
    return (
      <AUX>
        <div className="page-title-box">
          <div className="row align-items-center">
            {/* //Old Kashan 29-10-2019
                        <div className="col-3 align-self-baseline">
                        </div> */}
            <div className="col-md-6 col-lg-6 col-xl-6 col-sm-6 col-xs-6 text-center">
              <h4 className="page-title-search">{this.state.pageTitle}</h4>
              <form
                role="search"
                className="app-search mt-0"
                onSubmit={this.handleFormSearch}
              >
                <div className="form-group mb-0">
                  <input
                    name="searchText"
                    type="text"
                    id="keyword"
                    value={this.state.searchText}
                    onChange={this.searchTextChangeHandler}
                    className="form-control mb-1 w-100"
                    placeholder="Member Search.."
                  />
                  <button type="submit">
                    <i className="fa fa-search" /> Search
                  </button>
                  <span className="text-danger">
                    {this.state.searchText_err}
                  </span>

                  {/* <a className="as-link" href="#" onClick={() => $(".advance-search").toggleClass("d-none")}>
                                        <i className="fas fa-caret-down" /> ADVANCED SEARCH
                                    </a> */}
                </div>
              </form>
            </div>
            {!this.state.isLookup && (
              <div className="col-md-6 col-lg-6 col-xl-6 col-xs-6 col-sm-6 text-left">
                <div className="row">
                  {this.state.perms.permissions && (
                    <div className="col-12 mb-2">
                      <div className="search-btn-panel">
                        {/* <a className="search-link" href="#" dpata-toggle="modal" data-target="#"> */}
                        {this.state.perms.permissions.canView && (
                          <>
                            <button
                              type="button"
                              class="btn btn-primary"
                              id="modalOpenButton"
                              data-toggle="modal"
                              data-target=".AdvanceFilterModal"
                              style={{ display: "none" }}
                            ></button>
                            <a
                              className="search-link"
                              style={{ cursor: "pointer" }}
                            >
                              Advanced Filter
                            </a>
                          </>
                        )}

                        {this.state.perms.permissions.canAdd && (
                          <>
                            <span className="search-link-line">|</span>
                            <Link
                              className="search-link"
                              to={{
                                pathname: "/directory/AddNewUser",
                                type: "add",
                                uid: 0,
                              }}
                              color="secondary "
                            >
                              Add Member
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* //Old Kashan
                                         <div className="col">Show:</div>
                                        <div className="col-auto">
                                            <input
                                                type="checkbox"
                                                id="showActive"
                                                switch="bool"
                                                checked={this.props.args.showActive}
                                                onChange={this.handleShowActive}
                                            />
                                            <label htmlFor="showActive" className="size2" data-on-label="Active" data-off-label="All" />
                                        </div> */}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row advance-search d-none">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <form
                  action="#"
                  className="form-horizontal"
                  onSubmit={this.handleAdvSubmit}
                >
                  <div className="row">
                    <div className="col-auto mr-2 align-self-center">
                      <span>Filter Type: </span>
                    </div>
                    <div className="col-auto">
                      <select
                        className="browser-default custom-select"
                        id="filterType"
                      >
                        {/* <option value="Active">Member Active</option> */}
                        <option value="address">Address</option>
                        <option value="careerLevel">Career Level</option>
                        <option value="CommMethods">
                          Communication Methods
                        </option>
                        <option value="dateofBirth">Date of Birth</option>
                        <option value="DutyStation">Duty Station</option>
                        <option value="emailAddress">Email Address</option>
                        <option value="faaid">Employee Common Id</option>
                        <option value="Facility">Facility</option>
                        <option value="FacilityRoutingSymbol">
                          Facility Routing Symbol
                        </option>
                        <option value="FLSACategory">FLSA Category</option>
                        <option value="Status">Member Status</option>
                        <option value="MemberType">Member Type</option>
                        <option value="names">Name</option>
                        <option value="NatcaBargainingUnitDate">
                          Natca Bargaining Unit Date
                        </option>
                        <option value="OccupationSeries">
                          Occupation Series
                        </option>
                        <option value="PayGrade">Pay Grade</option>
                        <option value="PlannedRetirement">
                          Mandatory Retirement Date
                        </option>
                        <option value="Retirement">Retirement Date</option>
                        <option value="Region">Region</option>
                        <option value="SCD">SCD Date</option>
                        <option value="shirtsize">Shirt Size</option>
                        <option value="Unit">Unit</option>
                        <option value="VetStatus">Vet Status</option>
                      </select>
                    </div>
                    <div className="col align-self-center">
                      {" "}
                      <button
                        type="button"
                        onClick={this.addFilter}
                        className="btn btn-primary mo-mt-2"
                      >
                        Add{" "}
                      </button>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col text-right align-self-center">
                          Operator:
                        </div>
                        <div className="col-auto text-right align-self-end">
                          <select
                            className="browser-default custom-select"
                            id="operator"
                          >
                            <option value="AND">AND</option>
                            <option value="OR">OR</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.filters.map((item, idx) => (
                    <div
                      key={idx}
                      className="bbLight"
                      data-repeater-list="group-a"
                    >
                      <div data-repeater-item className="row mt-3">
                        <div data-id={idx} className="col">
                          <Filter
                            row={item}
                            methods={this.filterHandlers}
                            idx={idx}
                          />
                        </div>
                        <div
                          data-id={idx}
                          className="col-auto align-self-center"
                        >
                          <button
                            type="button"
                            data-id={idx}
                            onClick={this.handleRemove}
                            className="btn btn-danger btn-sm"
                          >
                            <i data-id={idx} className="fas fa-trash-alt" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="col text-right mt-3 align-self-end">
                    <button className="btn btn-lg btn-primary waves-effect waves-light">
                      Search
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <AdvanceFilterModal /> */}
      </AUX>
    );
  }
}

export default AdvanceSearch;
// export default connect(state => ({ filterState: state.advancedFilter }), {
//   ...actionFilter
// })(AdvanceSearch);
